// Product detail content — highlights, technical specs, and box contents.
// Sourced from the official owner's manuals (models CFWS10 / CFCL10 / CFBS520).
// Keep the spec values matched to the manuals; they're stated as fact on the PDP.
const ProductSpecs = {

    'water-sensor': {
        tagline: 'Early leak & freeze detection',
        highlights: [
            {
                icon: 'fas fa-tint',
                title: 'Reacts the instant it gets wet',
                copy: '23-karat gold contacts sense the first drop of a leak — under sinks, behind the fridge, by the water heater.',
            },
            {
                icon: 'fas fa-snowflake',
                title: 'Catches the freeze, too',
                copy: 'A built-in low-temperature alert warns you before a pipe has the chance to burst.',
            },
            {
                icon: 'fas fa-broadcast-tower',
                title: 'Extends its own range',
                copy: 'Every sensor repeats the network’s signal, so your coverage grows as you add more.',
            },
        ],
        specs: [
            { label: 'Detection', value: 'Water contact + low-temperature (freeze)' },
            { label: 'Sensor contacts', value: '23-karat gold-plated' },
            { label: 'On-device alerts', value: 'Internal horn + backlit LED icons' },
            { label: 'Remote alerts', value: 'Text, email & app' },
            { label: 'Wireless', value: 'Proprietary radio · 905.2 / 913.2 MHz' },
            { label: 'Range', value: 'Up to 200 ft (70 m), open area' },
            { label: 'Network', value: 'Repeats signals to extend coverage' },
            { label: 'Power', value: 'Internal 10 year lithium battery' },
            { label: 'Mounting', value: 'Adhesive feet, rubber feet, or vertical screw' },
            { label: 'Works with', value: 'Smart Hub + Aqua Link app' },
            { label: 'Assembly', value: 'Assembled in the U.S.A.' },
        ],
        inTheBox: ['Water Sensor', '2-sided adhesive feet', 'Rubber feet', 'Vertical mounting screw', 'Instruction manual'],
    },

    'comm-link-smart-hub': {
        tagline: 'The hub that connects it all',
        highlights: [
            {
                icon: 'fas fa-broadcast-tower',
                title: 'The brain of the network',
                copy: 'Connects every Aqua Link device and relays its status to your phone in real time.',
            },
            {
                icon: 'fas fa-network-wired',
                title: 'Wired or wireless',
                copy: 'Plug into Ethernet for the most reliable link, or place it anywhere over Wi-Fi.',
            },
            {
                icon: 'fas fa-plug',
                title: 'Always on',
                copy: 'AC powered with no batteries to replace, for peace of mind.',
            },
        ],
        specs: [
            { label: 'Internet connectivity', value: 'Ethernet (wired) + Wi-Fi 2.4 GHz' },
            { label: 'Role', value: 'Relays all sensor data to the internet for phone alerts' },
            { label: 'Sensor network', value: 'Proprietary radio · 905 / 913 MHz' },
            { label: 'On-device', value: '4 backlit status icons + internal piezo horn' },
            { label: 'Controls', value: 'Dual-function test / silence button' },
            { label: 'Power', value: 'AC adapter — no batteries required' },
            { label: 'Works with', value: 'All Aqua Link devices + app' },
            { label: 'Assembly', value: 'Assembled in the U.S.A.' },
        ],
        inTheBox: ['Smart Hub', 'AC power adapter', '3 ft Ethernet cable', 'Instruction manual'],
    },

    'bed-shaker': {
        tagline: 'Never sleep through an alarm',
        highlights: [
            {
                icon: 'fas fa-bed',
                title: 'Wakes you through the mattress',
                copy: 'The shaker slips under your mattress and vibrates the bed the moment any alarm sounds.',
            },
            {
                icon: 'fas fa-volume-up',
                title: 'A 520 Hz low-frequency horn',
                copy: 'Tuned at ear level for the hearing impaired, heavy sleepers, and children.',
            },
            {
                icon: 'fas fa-link',
                title: 'Connects to every alarm',
                copy: 'Any Aqua Link device on the network can trigger it — water or freeze.',
            },
        ],
        specs: [
            { label: 'Alert type', value: '520 Hz low-frequency horn + vibration' },
            { label: 'Shaker unit', value: 'Inserts under the mattress; vibrates in alarm' },
            { label: 'Cord length', value: '6 ft (bed to nightstand)' },
            { label: 'On-device', value: '4 illuminated status icons' },
            { label: 'Controls', value: 'Dual-function test / silence button' },
            { label: 'Power', value: '3 × Lithium Manganese (Duracell DL123)' },
            { label: 'Placement', value: 'Bedrooms / sleeping rooms' },
            { label: 'Works with', value: 'Smart Hub + Aqua Link app' },
            { label: 'Assembly', value: 'Assembled in the U.S.A.' },
        ],
        inTheBox: ['Speaker unit', 'Under-mattress shaker unit', '3 × Duracell DL123 batteries', 'Instruction manual'],
    },
};

export const getSpecs = (handle) => ProductSpecs[handle] || null;

export default ProductSpecs;
